import { FleetMetrics } from './FleetMetrics';
import { DevicesMap } from './DevicesMap';
import { Box } from '@mui/material';
import { MapStyleToggle } from './MapStyleToggle';
import { useIsMobile } from '../../../hooks/useIsMobile';

export const MapComponent = () => {
  const isMobile = useIsMobile();

  return (
    <Box
      data-testid="Map Component"
      width="100%"
      height="100%"
      position="relative"
    >
      <DevicesMap />
      {!isMobile && <FleetMetrics />}
      <MapStyleToggle />
    </Box>
  );
};
